import type { ReactNode } from 'react'
import styles from '@/pages/Admin/Admin.module.css'

interface AdminPageProps {
  title: string
  subtitle?: string
  loading?: boolean
  error?: string | null
  children?: ReactNode
  wide?: boolean
}

export function AdminPage({
  title,
  subtitle,
  loading = false,
  error,
  children,
  wide = false,
}: AdminPageProps) {
  return (
    <div className={`${styles.adminPage} ${wide ? styles.adminPageWide : ''}`.trim()}>
      <header className={styles.sectionHeader}>
        <h1 className={styles.sectionTitle}>{title}</h1>
        {subtitle && <p className={styles.sectionSubtitle}>{subtitle}</p>}
      </header>

      {error && (
        <div className={styles.erroSection}>
          <p className={styles.erro}>{error}</p>
        </div>
      )}

      {loading ? (
        <div className={styles.loadingBox} role="status">
          <span className={styles.loadingSpinner} aria-hidden />
          <p>A carregar…</p>
        </div>
      ) : (
        <div className={styles.pageStack}>{children}</div>
      )}
    </div>
  )
}
